// extracted by mini-css-extract-plugin
module.exports = {"root":"Tab_root__Eyujl","button":"Tab_button__rHXbB","inline":"Tab_inline__QODyo","active":"Tab_active__RcDOF","dark":"Tab_dark__2aaWW","light":"Tab_light__jad0o"};